module.exports = __webpack_public_path__ + "static/media/IMG_1269-(2).ac9a5667.jpg";